var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTarjetaDeCredito(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.68 28.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f44d3b;}.cls-2{fill:#d32a0f;}.cls-3{fill:#a00d05;}.cls-4{fill:#073c60;}.cls-5{fill:#00233f;}.cls-6{fill:#23c181;}.cls-7{fill:#0caa7d;}.cls-8{fill:#f4ad31;}.cls-9{fill:#e2821a;}.cls-10{fill:#eadaea;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 20otros") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.61,26.76a1.83,1.83,0,0,1-1.81,1.8H1.8A1.83,1.83,0,0,1,0,26.76V1.8A1.83,1.83,0,0,1,1.8,0H44.88a1.83,1.83,0,0,1,1.8,1.8v25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,1.8A1.83,1.83,0,0,1,1.8,0H44.88a1.83,1.83,0,0,1,1.8,1.8v25a1.83,1.83,0,0,1-1.8,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.29,0H44.8a1.83,1.83,0,0,1,1.81,1.8v25a1.83,1.83,0,0,1-1.81,1.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 5.26,
    width: 46.61,
    height: 9.02
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "46.61 14.28 46.61 5.26 0 5.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18,18.19a.59.59,0,0,1-.6.6H5.11a.55.55,0,0,1-.6-.6v-.37a.54.54,0,0,1,.6-.53h12.4a.59.59,0,0,1,.61.6v.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18,21.2a.59.59,0,0,1-.6.6H5.11a.56.56,0,0,1-.6-.6v-.38a.53.53,0,0,1,.6-.52h12.4a.59.59,0,0,1,.61.6v.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18,24.2a.59.59,0,0,1-.6.61H5.11a.56.56,0,0,1-.6-.61v-.37a.54.54,0,0,1,.6-.53h12.4a.6.6,0,0,1,.61.6v.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M34.2,21.2a4.51,4.51,0,0,1,1.66-3.46,4.5,4.5,0,0,0-2.78-1,4.44,4.44,0,1,0,0,8.87,4.49,4.49,0,0,0,2.78-1A4.27,4.27,0,0,1,34.2,21.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M33.08,25.63a4.49,4.49,0,0,0,2.78-1A4.27,4.27,0,0,1,34.2,21.2a4.51,4.51,0,0,1,1.66-3.46,4.5,4.5,0,0,0-2.78-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M38.64,16.76a4.47,4.47,0,0,0-2.78,1,4.29,4.29,0,0,1,1.65,3.46,4.53,4.53,0,0,1-1.65,3.46,4.47,4.47,0,0,0,2.78,1,4.39,4.39,0,0,0,4.43-4.43A4.45,4.45,0,0,0,38.64,16.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.64,25.63a4.44,4.44,0,0,0,0-8.87"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 5.49,
    cy: 12.03,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 9.55,
    cy: 12.03,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 13.61,
    cy: 12.03,
    r: 0.83
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarjetaDeCredito);
export default __webpack_public_path__ + "static/media/tarjeta-de-credito.3e977190c7eda2e0d4d06f009902313e.svg";
export { ForwardRef as ReactComponent };